import React from 'react'
import './DeleteButton.css'



const DeleteButton = ({id,onClick}) => {
  return (
    <div id={id} className="delete hide" onClick={onClick}>X</div>
  )
}

export default DeleteButton